module.exports = __webpack_public_path__ + "static/media/robot-icon.46406648.webp";